"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Flame } from "lucide-react";
export default function BookingCallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="141222" id="cta-banner" className="relative flex w-full items-center justify-center overflow-hidden bg-primary py-24 dark">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div className="h-[300px] w-[300px] animate-pulse rounded-full bg-accent/20 blur-[100px] md:h-[600px] md:w-[600px] md:blur-[150px]" />
      </div>

      <div className="container relative z-10 px-4 md:px-6">
        <div ref={ref} className={`mx-auto flex max-w-4xl flex-col items-center rounded-2xl border border-white/10 bg-primary/40 p-8 text-center shadow-2xl backdrop-blur-xl transition-all duration-1000 md:p-16 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <Flame className="mb-6 h-12 w-12 animate-bounce text-accent" style={{
          animationDuration: "3s"
        }} />

          <h2 className="mb-8 font-serif text-4xl font-bold tracking-tight text-primary-foreground md:text-6xl">
            Ready to Restore Your Mobility?
          </h2>

          <div className="mb-10 flex w-full flex-col gap-4 sm:w-auto sm:flex-row">
            <Button size="lg" className="h-14 rounded-full border-0 bg-accent px-8 text-lg font-semibold text-accent-foreground shadow-lg transition-transform duration-300 hover:scale-105 hover:bg-accent/90" asChild>
              <Link to="/ServiceNameInLimassolNicosiaCyprusPage">Book in Limassol</Link>
            </Button>
            <Button size="lg" variant="outline" className="h-14 rounded-full border-accent bg-transparent px-8 text-lg font-semibold text-accent hover:bg-accent/10 hover:text-accent" asChild>
              <Link to="/ServiceNameInLimassolNicosiaCyprusPage">Book in Nicosia</Link>
            </Button>
          </div>

          <Link to="mailto:bodywerkscy@gmail.com" className="text-sm text-primary-foreground/70 decoration-accent underline-offset-4 transition-colors hover:text-accent hover:underline">
            bodywerkscy@gmail.com
          </Link>
        </div>
      </div>
    </section>;
}